module.exports = "<button class=\"kd-icon\"\r\n    type=\"button\"\r\n    title=\"Eliminar dirección\"\r\n    ng-click=\"$ctrl.eliminando = true; $event.stopPropagation();\">\r\n  <i class=\"fa fa-trash\"></i>\r\n</button>\r\n\r\n<empresa-informacion-direcciones-eliminar-confirmacion\r\n    ng-if=\"$ctrl.eliminando\"\r\n    empresa-id=\"$ctrl.empresaId\"\r\n    indice=\"$ctrl.indice\"\r\n    matriz=\"$ctrl.matriz\"\r\n    calle=\"$ctrl.calle\"\r\n    on-close=\"$ctrl.eliminar($event.detail)\"></empresa-informacion-direcciones-eliminar-confirmacion>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/empresa/components/informacion/direcciones/eliminar/template.html
// module id = 2544
// module chunks = 0